<div class="center-wrapper">
<div class="profile-info-card" [ngClass]="{'actived': isEditMode}">
  <div class="header">
   <div class="title-with-icon">
      <img *ngIf="isEditMode" (click)="toggleEdit()" src="assets/images/leftArrow.png"/>
      <h3>Profile Information</h3>
    </div>
    <p class="subtitle2" *ngIf="!isEditMode">Keep your profile information updated</p>
    <p class="subtitle" *ngIf="isEditMode">Update your personal information and profile photo</p>

    <div class="btn-with-icon" style="cursor: pointer;">
    </div>

  </div>
  <hr />

  <!-- View Mode -->
    <div class="profile-section" *ngIf="!isEditMode">
      <div class="profile-pic-container">
        <ng-container *ngIf="profileImg; else noImg">
          <img [src]="profileImg" alt="Profile Image" class="profile-pic" />
        </ng-container>
        <ng-template #noImg>
          <div class="profile-placeholder">
            {{ profileData?.first_name?.charAt(0)?.toUpperCase() }}
          </div>
        </ng-template>
        <div class="edit-icon">
          <input type="file" #fileInput style="display: none" (change)="onFileChanged($event)"/>
          <i class="bi bi-pencil-fill" (click)="changePhoto(fileInput)"></i>
        </div>
      </div>

      <h4 class="username">{{ profileData?.first_name }} {{ profileData?.last_name }}</h4>
      <p class="email">{{ profileData?.email }}</p>

      <button class="edit-btn" (click)="toggleEdit()" *ngIf="!isEditMode">Edit Profile</button>
    </div>

    <div class="info-grid" *ngIf="!isEditMode">
        <div class="info-item">
            <label class="info-label">First Name</label>
            <p>{{ profileData?.first_name }}</p>
        </div>
        <div class="info-item">
            <label class="info-label">Last Name</label>
            <p>{{ profileData?.last_name }}</p>
        </div>
        <div class="info-item">
            <label class="info-label">Email</label>
            <p>{{ profileData?.email }}</p>
        </div>
        <div class="info-item">
            <label class="info-label">Gender</label>
            <p>{{ (profileData?.gender | titlecase)}}</p>
        </div>
        <div class="info-item">
            <label class="info-label">Phone Number</label>
            <p>{{ profileData?.mobile}}</p>
        </div>
        <div class="info-item">
            <label class="info-label">Date Of Birth</label>
            <p>{{ profileData?.dob | date:'MMM d, y' }}</p>
        </div>
        <div class="info-item">
            <label class="info-label">Country</label>
            <p>{{ profileData?.country }}</p>
        </div>
        <div class="info-item">
            <label class="info-label">Residence Address</label>
            <p>{{ profileData?.home_address }}</p>
        </div>
    
        <div class="info-item">
            <label class="info-label">Work Address</label>
            <p>{{ profileData?.work_address}}</p>
        </div>
    </div>
  <!-- View Mode -->


  <!-- Edit Mode -->
    <div class="profile-photo-section edd" *ngIf="isEditMode">
      <div class="photo-wrapper">
        <div class="photo-container">
          <ng-container *ngIf="profileImg; else noImage">
            <img [src]="profileImg" alt="Profile" class="profile-img" />
          </ng-container>
          <ng-template #noImage>
            <div class="placeholder-img">
              {{ profileData?.first_name?.charAt(0)?.toUpperCase() }}
            </div>
          </ng-template>   

          <!-- Profile with camera icon -->
          <div class="profile-photo-container">
            <div class="camera-icon" (click)="openCamera()">
              <i class="bi bi-camera-fill"></i>
            </div>
          </div>
          <!-- Camera modal -->
          <div *ngIf="showCamera" class="camera-modal">
            <video #video autoplay></video>
            <button class="camCapture" (click)="capturePhoto(video)">Capture</button> &nbsp;
            <button class="camCancel" (click)="closeCamera()">Cancel</button>
            <canvas #canvas hidden></canvas>
          </div>
          <!-- Profile with camera icon ends -->

        </div>
        <div class="photo-details">
          <h6 class="photo-title">Profile Photo</h6>
          <small class="photo-hint">PNG or JPG up to 2MB</small>

          <div class="btn-group mt-2">
            <input type="file" #fileInput style="display: none" (change)="onFileChanged($event)"/>
            <button class="btn btn-outline-primary btn-sm change-btn me-3" (click)="changePhoto(fileInput)">Change</button>
            <button *ngIf="profileImg" class="btn btn-link remove-btn btn-sm p-0" (click)="removePhoto();onDelete()">Remove</button>
          </div>

        </div>
      </div>
    </div>

    <form class="edit-form-grid" (ngSubmit)="onSubmit()" *ngIf="isEditMode" novalidate autocomplete="off">
      <!-- First Name -->
      <div class="form-group">
        <label>First Name <span style="color: red;">*</span></label>
        <input 
          type="text" 
          [(ngModel)]="profileData.first_name" 
          name="firstName" 
          (keydown)="preventLeadingSpace($event); preventInvalidStart($event)" 
          (input)="validateName('first_name')" 
          placeholder="Enter Your First Name" 
        />
        <span style="color: red; font-size: 12px; display: block; margin-top: 4px;" *ngIf="validationErrors['first_name']">
          First Name is required
        </span>
      </div>

      <!-- Last Name -->
      <div class="form-group">
        <label>Last Name <span style="color: red;">*</span></label>
        <input 
          type="text" 
          [(ngModel)]="profileData.last_name" 
          name="lastName" 
          (keydown)="preventLeadingSpace($event); preventInvalidStart($event)" 
          (input)="validateName('last_name')" 
          placeholder="Enter Your Last Name" 
        />
        <span style="color: red; font-size: 12px; display: block; margin-top: 4px;" *ngIf="validationErrors['last_name']">
          Last Name is required
        </span>
      </div>

      <!-- Email -->
      <div class="form-group">
        <label>
          Email <span style="color: red;">*</span>
          <span *ngIf="isEmailReadonly" class="readonly-indicator" title="This field cannot be edited as it is verified on your account">
            <i class="bi bi-lock-fill"></i>
          </span>
        </label>
        <input 
          type="email" 
          [(ngModel)]="profileData.email" 
          name="email" 
          (keydown)="preventLeadingSpace($event)" 
          placeholder="Enter Your Email Address" 
          [class.disInp]="isEmailReadonly" 
          [readonly]="isEmailReadonly"
          [disabled]="isEmailReadonly"
        />
        <span style="color: red; font-size: 12px; display: block; margin-top: 4px;" *ngIf="validationErrors['email']">
          Email is required
        </span>
        <span style="color: red; font-size: 12px; display: block; margin-top: 4px;" *ngIf="validationErrors['email_format']">
          Please enter a valid email address
        </span>
        <!-- <small *ngIf="isEmailReadonly" class="readonly-hint">
          <i class="bi bi-info-circle"></i>
        </small> -->
      </div>

      <!-- Gender -->
      <div class="form-group">
        <label>Gender</label>
        <select [(ngModel)]="profileData.gender" name="gender">
          <option value="" disabled>Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="others">Others</option>
        </select>
      </div>

      <!-- Phone Number -->
      <div class="form-group phone-input">
        <label>
          Phone Number <span style="color: red;">*</span>
          <span *ngIf="isMobileReadonly" class="readonly-indicator" title="This field cannot be edited as it is verified on your account">
            <i class="bi bi-lock-fill"></i>
          </span>
        </label>
        <div class="phone-wrapper">
          <div class="prefix-box" [class.readonly-prefix]="isMobileReadonly">
            {{ countryMap[countryCode]?.mobile }}
          </div>
          <input 
            type="text" 
            [(ngModel)]="profileData.mobile" 
            name="phone" 
            placeholder="Enter Your Phone Number"
            inputmode="numeric" 
            maxlength="10" 
            pattern="[0-9]*" 
            (keydown)="preventLeadingSpace($event)"
            (paste)="preventInvalidPaste($event)" 
            (keypress)="allowOnlyNumbers($event)"
            [class.disInp]="isMobileReadonly" 
            [readonly]="isMobileReadonly"
            [disabled]="isMobileReadonly"
            (ngModelChange)="clearError('mobile')"
          />
        </div>
        <span style="color:red;font-size:12px;" *ngIf="validationErrors['mobile'] === 'required'">
          Phone Number is required
        </span>
        <span style="color:red;font-size:12px;" *ngIf="validationErrors['mobile'] === 'invalid'">
          Enter valid 10-digit mobile number
        </span>
        <!-- <small *ngIf="isMobileReadonly" class="readonly-hint">
          <i class="bi bi-info-circle"></i> 
        </small> -->
      </div>

      <!-- Date of Birth -->
      <div class="form-group">
        <label>Date Of Birth</label>
        <div class="date-input-wrapper">
          <input type="text" bsDatepicker container="body" #dobDp="bsDatepicker" [(ngModel)]="profileData.dob" name="dob"
            [bsConfig]="datePickerConfig" class="form-control" placeholder="Select Date" readonly />
          <img src="assets/cal-icon.svg" class="calendar-icon" (click)="dobDp.toggle()" />
        </div>
      </div>

      <!-- Residence Address -->
      <div class="form-group">
        <label>Residence Address <span style="color: red;">*</span></label>
        <textarea 
          rows="3"
          (ngModelChange)="clearError('home_address')"
          [(ngModel)]="profileData.home_address" 
          name="homeAddress" 
          (keydown)="preventLeadingSpace($event); preventInvalidStart($event)" 
          placeholder="Enter Your Residence Address"
        ></textarea>
        <span style="color: red; font-size: 12px; display: block; margin-top: 4px;" *ngIf="validationErrors['home_address']">
          Residence Address is required
        </span>
      </div>

      <!-- Work Address -->
      <div class="form-group">
        <label>Work Address</label>
        <textarea 
          rows="3" 
          [(ngModel)]="profileData.work_address" 
          name="workAddress" 
          (keydown)="preventLeadingSpace($event); preventInvalidStart($event)" 
          placeholder="Enter Your Work Address"
        ></textarea>
      </div>
            <!-- Country -->
      <div class="form-group">
        <label>Country</label>
        <input 
          type="text" 
          [(ngModel)]="profileData.country" 
          name="country" 
          placeholder="Enter Your Country" 
          class="disInp" 
          [readonly]="true" 
        />
      </div>
      <!-- ===== SECURITY SECTION ===== -->
      <div class="form-group pwd-section-header" style="grid-column: span 2;">
        <div class="pwd-section-toggle" (click)="togglePasswordSection()">
          <span>
            <i class="bi bi-shield-lock me-2"></i>
            Security
          </span>
          <i class="bi" [ngClass]="showPasswordSection ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        </div>
      </div>

      <!-- Password fields sub-grid wrapper -->
      <div class="pwd-fields-wrapper" *ngIf="showPasswordSection">

        <!-- Current Password (only when user already has a password) -->
        <ng-container *ngIf="hasPassword">
          <div class="form-group current-password">
            <label>Current Password <span style="color: red;">*</span></label>
            <div class="pwd-input-wrapper">
              <input
                [type]="showCurrentPwd ? 'text' : 'password'"
                [(ngModel)]="passwordData.current"
                name="currentPassword"
                autocomplete="new-password"
                (keydown)="preventPwdSpace($event)"
                (ngModelChange)="clearPwdError('current')"
                placeholder="Enter Current Password"
              />
              <i class="bi pwd-toggle-icon"
                 [ngClass]="showCurrentPwd ? 'bi-eye' : 'bi-eye-slash'"
                 (click)="showCurrentPwd = !showCurrentPwd"></i>
            </div>
            <span class="pwd-error" *ngIf="passwordErrors['current']">Current Password is required</span>
          </div>
          <!-- empty cell to keep current password on the left only -->
          <div></div>
        </ng-container>

        <!-- New Password (left) -->
        <div class="form-group">
          <label>New Password <span style="color: red;">*</span></label>
          <div class="pwd-input-wrapper">
            <input
              [type]="showNewPwd ? 'text' : 'password'"
              [(ngModel)]="passwordData.newPwd"
              name="newPassword"
              autocomplete="new-password"
              (keydown)="preventPwdSpace($event)"
              (input)="validateNewPassword($event)"
              (ngModelChange)="clearPwdError('newPwd'); validateConfirmPassword()"
              placeholder="Enter New Password"
            />
            <i class="bi pwd-toggle-icon"
               [ngClass]="showNewPwd ? 'bi-eye' : 'bi-eye-slash'"
               (click)="showNewPwd = !showNewPwd"></i>
          </div>
          <span class="pwd-error" *ngIf="passwordErrors['newPwd']">{{ passwordErrors['newPwd'] }}</span>
        </div>

        <!-- Re-type New Password (right, always beside New Password) -->
        <div class="form-group">
          <label>Re-type New Password <span style="color: red;">*</span></label>
          <div class="pwd-input-wrapper">
            <input
              [type]="showConfirmPwd ? 'text' : 'password'"
              [(ngModel)]="passwordData.confirmPwd"
              name="confirmPassword"
              autocomplete="new-password"
              (keydown)="preventPwdSpace($event)"
              (ngModelChange)="validateConfirmPassword()"
              placeholder="Re-enter New Password"
            />
            <i class="bi pwd-toggle-icon"
               [ngClass]="showConfirmPwd ? 'bi-eye' : 'bi-eye-slash'"
               (click)="showConfirmPwd = !showConfirmPwd"></i>
          </div>
          <span class="pwd-error" *ngIf="passwordErrors['confirmPwd']">{{ passwordErrors['confirmPwd'] }}</span>
        </div>

        <!-- Update Password button -->
        <div class="pwd-action-row">
          <button type="button" class="update-pwd-btn" (click)="onUpdatePasswordClick()">
            Update Password
          </button>
        </div>

      </div>
      <!-- ===== END SECURITY SECTION ===== -->

      <!-- Buttons -->
      <div class="form-actions">
        <button type="button" class="cancel-btn" (click)="onCancel()">Cancel</button>
        <button type="submit" class="save-btn">Save Changes</button>
      </div>
    </form>
  <!-- Edit Mode -->

</div>
</div>